import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="nav">
        <div className="nav-brand"></div>
        <ul className="nav-links">
          <li><button className="nav-link" onClick={() => scrollToSection('home')}>Home</button></li>
          <li><button className="nav-link" onClick={() => scrollToSection('experience')}>Experience</button></li>
          <li><button className="nav-link" onClick={() => scrollToSection('skills')}>Skills</button></li>
          <li><button className="nav-link" onClick={() => scrollToSection('contact')}>Contact</button></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;

